import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { PATH } from 'src/services/api/team/settings/constants';
import type { TeamSettings } from 'src/services/api/team/settings/types';
import { QUERY_KEY } from 'src/services/api/team/settings/use-team-settings';

type Request = TeamSettings;

export const useUpdateTeamSettings = () => {
    const queryClient = useQueryClient();

    return useMutation<void, unknown, Request>(
        async (payload) => {
            await apiClient(PATH, {
                method: 'patch',
                json: payload
            });
        },
        {
            onSuccess: () => queryClient.invalidateQueries(QUERY_KEY)
        }
    );
};